import type { ImageLoader } from 'next/image';

import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';

const BYPASS_PROXY_REGEX = /^https?:\/\/[^/]+\/media\//i;

export const getImgLoader = (image: VehicleImage, fallbackLoader: ImageLoader): ImageLoader => {
  if (BYPASS_PROXY_REGEX.test(image.url)) return ({ src }) => src;
  return fallbackLoader;
};
